import styled from 'styled-components'

export const SceneWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`

export const SceneCanvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
`
